export class FieldConstants {
    public static checkout = "StoreCheckout";
    public static cartItem = "StoreCartItem";
}
